import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  API_SERVICE_CONFIG,
  IApiServiceConfig,
} from '@fullyops/data/base/configuration/api-service-config';
import { Observable } from 'rxjs';
import { Country } from './country';

@Injectable({ providedIn: 'root' })
export class ApiCountriesAdapterService {
  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  getCountries(): Observable<Country[]> {
    const params = { page: -1 };
    return this.http.get<Country[]>(this.config.url + 'companies/countries', {
      params,
    });
  }
}
